<template>
  <div class="animated fadeIn" id="list-mail">
    <b-card>
      <b-card-title>Mail n° {{mail.id}} <b-button class="float-right" variant="secondary" @click="returnBack">Retour</b-button></b-card-title>
      <b-card class="block-mail" :class="mail.is_neutralised ? 'neutralise' : ''">
        <b-list-group flush>
          <b-list-group-item>
            <b-row>
              <b-col sm="6" class="borded-right">
                <b-card-text>
                  <b-row :class="`mb-2`">
                    <b-col sm="1">
                      De :
                    </b-col>
                    <b-col sm="11">
                      {{ mail.mail_from }}
                    </b-col>
                  </b-row>
                  <b-row :class="`mb-2`">
                    <b-col sm="1">
                      A :
                    </b-col>
                    <b-col sm="11">
                      {{ mail.mail_to }}
                    </b-col>
                  </b-row>
                  <b-row :class="`mb-2`">
                    <b-col sm="1">
                      Cc :
                    </b-col>
                    <b-col sm="11">
                      {{ mail.mail_cc }}
                    </b-col>
                  </b-row>
                  <b-row :class="`mb-2`">
                    <b-col sm="1">
                      Cci :
                    </b-col>
                    <b-col sm="11">
                      {{ mail.mail_bcc }}
                    </b-col>
                  </b-row>
                  <b-row :class="`mb-2`">
                    <b-col sm="1">
                      Date :
                    </b-col>
                    <b-col sm="11">
                      {{ formatDate(mail.date_envoi_mail) }}
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-col>
              <b-col sm="6">
                <b-card-text>
                  <ul class="liste-pj">
                    <li v-for="pj in shownPj" :key="pj.id"><img class="mr-2" :src="getIconSrc(pj)">
                      <span v-if="!mail.is_neutralised && forbidenExtension.indexOf(pj.extension.trim().toLowerCase()) === -1"><a href="#" @click.prevent="download(pj)" >{{ pj.nom }} </a> {{ getReadableFileSize(pj.taille) }} <i v-if="dangerousExtension.indexOf(pj.extension.trim().toLowerCase()) !== -1" class="fa fa-exclamation-triangle" v-b-popover.hover.top="'Attention ce fichier peut contenir du code malveillant, veuillez ne pas activer les macros si vous n\'êtes pas sûr.e de la provenance'"></i></span>
                      <span v-if="forbidenExtension.indexOf(pj.extension.trim().toLowerCase()) !== -1">{{ pj.nom }} {{ getReadableFileSize(pj.taille) }} <i class="fa fa-window-close-o" v-b-popover.hover.top="'Ce fichier ne fait pas partie des fichiers autorisés'"></i></span>
                      <span v-if="mail.is_neutralised && forbidenExtension.indexOf(pj.extension.trim().toLowerCase()) === -1">{{ pj.nom }} {{ getReadableFileSize(pj.taille) }}</span>
                     </li>
                  </ul>
                  <a v-if="filteredPj.length > 0" href="#" v-b-toggle.collapse-1>Voir les pj filtrées ({{ filteredPj.length }})</a>
                  <b-collapse id="collapse-1" class="mt-2">
                    <ul class="liste-pj">
                      <li v-for="pj in filteredPj" :key="pj.id"><img class="mr-2" :src="getIconSrc(pj)">
                      <span v-if="!mail.is_neutralised && forbidenExtension.indexOf(pj.extension.trim().toLowerCase()) === -1"><a href="#" @click.prevent="download(pj)" >{{ pj.nom }} </a> {{ getReadableFileSize(pj.taille) }} <i v-if="dangerousExtension.indexOf(pj.extension.trim().toLowerCase()) !== -1" class="fa fa-exclamation-triangle" v-b-popover.hover.top="'Attention ce fichier peut contenir du code malveillant, veuillez ne pas activer les macros si vous n\'êtes pas sûr.e de la provenance'"></i></span>
                      <span v-if="forbidenExtension.indexOf(pj.extension.trim().toLowerCase()) !== -1">{{ pj.nom }} {{ getReadableFileSize(pj.taille) }} <i class="fa fa-window-close-o" v-b-popover.hover.top="'Ce fichier ne fait pas partie des fichiers autorisés'"></i></span>
                      <span v-if="mail.is_neutralised && forbidenExtension.indexOf(pj.extension.trim().toLowerCase()) === -1">{{ pj.nom }} {{ getReadableFileSize(pj.taille) }}</span>
                     </li>
                    </ul>
                  </b-collapse>
                </b-card-text>
              </b-col>
            </b-row>
          </b-list-group-item>
          <b-list-group-item>
            <b-row>
              <b-col sm="6">
                <b-row>
                  <b-col sm="1">
                    Objet :
                  </b-col>
                  <b-col sm="11">
                    {{ mail.subject }}
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-list-group-item>
          <b-list-group-item>
            <b-row>
              <b-col class="nopadding" sm="12">
                <span class="float-right text-secondary">|<a href="" @click.prevent="toggleTextHtml">{{ showHtml ? 'HTML' : 'TEXT' }}</a>|</span>
                <b-card-text v-show="!showHtml" class="pre-formatted">
                  {{ mail.body_text }}
                </b-card-text>
                <b-card-text v-show="showHtml" v-html="mail.body_html">
                </b-card-text>
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
      </b-card>
      <b-card class="historique" :class="mail.is_neutralised ? 'neutralise' : ''">
        <b-row>
          <b-col sm="6" class="borded-right">
            <p>Suivi des actions :</p>
            <p v-for="(historique, key) in mail.historiques" :key="key"><i class="smaller">{{ formatDate(historique.created_at) }}</i> {{ historique.action }} <span v-if="historique.user_id !== 999999 && historique.gestionnaire"><i> par {{ historique.gestionnaire.prenom.substring(0,1).toUpperCase() }}. {{ historique.gestionnaire.nom.toUpperCase() }}</i></span></p>
          </b-col>
          <b-col sm="6">
            <b-row>
              <b-col sm="4">
                <p class="mt-1">Transférer vers</p>
              </b-col>
              <b-col sm="8">
                <b-form-select v-if="canDoTransfert() && !mail.is_neutralised" v-model="balSelected" :options="balsSelect" size="sm" class="mt-1 mb-1" @change="clearErrors"></b-form-select>
                <span class="field-error">{{ errors.balTransfert }}</span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <b-row class="info-dossier" v-if="mail.dossiers && mail.dossiers.length >0">
        <b-col sm=12>
          Dossier correspondant : n°<a :href="getHrefDossier()" target="_BLANK">{{ mail.dossiers[0].id }}</a>
        </b-col>
      </b-row>
      <b-row :class="mail.dossiers && mail.dossiers.length >0 ? '' : 'mt-1'">
        <b-col sm=12>
          <b-button v-if="canManageNeutralise() && !mail.is_deleted" class="float-left" variant="danger" @click="manageNeutralise">{{ mail.is_spam ? 'Ce n\'est pas un spam' : mail.is_neutralised ? 'Déneutraliser' : 'Neutraliser' }}</b-button>
          <b-button v-if="canManageNeutralise() && mail.is_spam && !mail.is_deleted" class="float-left ml-2" variant="warning" @click="deleteSpam()"><i class="fa fa-trash mr-1"></i>Supprimer</b-button>
          <b-button class="float-right" variant="warning" @click="returnBack"><i class="fa fa-arrow-left"></i> Retour</b-button>
          <b-button v-if="canDoTransfert() && !mail.is_neutralised" class="float-right mr-2" variant="primary" @click="initTransferer"><i class="fa fa-exchange"></i> Transférer</b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-modal size="xl" centered no-close-on-esc no-close-on-backdrop hide-header-close title="Ajouter un commentaire à mettre dans le mail traansféré" id="modal-commentaire" ref="modal-commentaire">
      <b-form>
        <b-row>
          <b-col sm="2">
            <label for="commentaire">Commentaire :</label>
          </b-col>
          <b-col sm="10">
            <b-form-textarea
              id="textarea"
              v-model="commentaire"
              placeholder="Saissez un commentaire si vous le souhaitez"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-col>
        </b-row>
      </b-form>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            class="float-right ml-2"
            @click="transferer()">
            <i class="fa fa-share"></i>
            Transférer
          </b-button>
          <b-button
            variant="secondary"
            class="float-right ml-2"
            @click="cancelTransfert()">
            <i class="fa fa-times"></i>
            Annuler
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth';
import { hasRule, espaceGestionRules as rules } from '@/utils/rulesHelper';
import { downloadFile, getFileIcon, getDangerousExtension, getForbidenExtension, isEmpty } from '@/utils/fileHelper';
import {getMainTreatmentBasedOnType} from "@/utils/communHelper";

export default {
  components: {},
  data() {
    return {
      id: '',
      mail: {},
      showHtml: true,
      balsTransfert: [],
      balsSelect: [],
      balSelected: null,
      filteredPj: [],
      shownPj: [],
      allTraitements: [],
      extensionIcon: [],
      dangerousExtension: getDangerousExtension,
      forbidenExtension: getForbidenExtension,
      commentaire: '',
      errors: {
        balTransfert: ''
      }
    }
  },
  async mounted() {
    this.id = this.$route.params.id
    await this.getAllTraitement();
    this.getMail()
    this.getBalsTransfert()
    this.extensionIcon = getFileIcon()
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json';
    this.$axios.defaults.headers.common['Provider'] = getProvider();
  },
  methods: {
    getMail() {
      let self = this;
      this.$store.commit("IS_LOADING", true);
      let mailId = this.id
      this.$axios
        .get("/espaceGestion/mail/show/" + mailId)
        .then(response => {
          this.$store.commit("IS_LOADING", false);
          // console.log(response.data)
          this.processDataMail(response.data.mail)
        })
        .catch(function(error) {
          self.$store.commit('IS_LOADING', false);
          let text = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';

          if (!isEmpty(error) && error.response && error.response.status === 403) {
            text = 'Vous n\'avez pas le droit de voir ce mail';
          }
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: text,
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    getAllTraitement() {
      return new Promise((resolve) => {
        let self = this;
        this.$axios
          .get("/administration/traitements")
          .then(response => {
            this.allTraitements = response.data.traitements;
            resolve();
          })
          .catch(() => {
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue pendant la récupération des traitements, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 6000
            });
            resolve();
          });
      });
    },
    processDataMail(mail) {
      this.mail = mail
      this.filteredPj = this.mail.pieces_jointes.filter( item => item.taille < 5000 )
      this.shownPj = this.mail.pieces_jointes.filter( item => item.taille >= 5000 )
      this.showHtml = !this.mail.is_from_forward
    },
    toggleTextHtml() {
      this.showHtml = !this.showHtml
    },
    getBalsTransfert() {
      let self = this;
      this.$store.commit("IS_LOADING", true);
      this.$axios
        .get("/espaceGestion/mail/getbaltransfert")
        .then(response => {
          this.$store.commit("IS_LOADING", false);
          // console.log(response.data)
          for(let bal of response.data.balsTransfert) {
            this.balsTransfert[bal.id] = bal
          }

          this.balsSelect = response.data.balsTransfert.map( bal => {return {'value': bal.id, 'text': bal.libelle}})
          this.balsSelect.unshift({'value': null, 'text': 'Choisissez une BAL'})
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    download(pj) {
      // console.log('pj',pj)
      let self = this
      let extension = pj.extension.trim()
      let libelleComplet = pj.nom.trim()
      let nomFichierArray = libelleComplet.split('.')
      nomFichierArray.pop()
      let libelle = nomFichierArray.join('.')
      let dataPost = {
        id: pj.id
      }

      this.$store.commit("IS_LOADING", true)

      this.$axios
        .post("/espaceGestion/mail/download", dataPost, { responseType: "arraybuffer" })
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          downloadFile(response, libelle, extension)
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          let errorText = "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI"
          if (error.response && error.response.status === 404 && self !== undefined ) {
            errorText = "La pièce jointe demandée n'existe pas"
          }
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: errorText,
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    canManageNeutralise() {
      return hasRule(rules.MANAGE_NEUTRALISE_RECEPTION_MAIL)
    },
    canDoTransfert() {
      return hasRule(rules.FORWARD_RECEPTION_MAIL)
    },
    initTransferer() {
      if (this.validateData()) {
        this.$swal
          .fire({
            title: "Êtes-vous sûr?",
            text: "Voulez-vous vraiment Transférer ce mail vers " + this.balsTransfert[this.balSelected].libelle + " ?",
            type: "warning",
            reverseButtons: true,
            showCancelButton: true,
            allowOutsideClick: false,
            cancelButtonColor: "#ff1744",
            confirmButtonText: "Annuler",
            cancelButtonText: "Transférer"
          })
          .then(result => {
            if (!result.value) {
              this.$refs['modal-commentaire'].show();
            }
          })
      }
    },
    transferer () {
      let self = this;
      this.$refs['modal-commentaire'].hide();
      this.$store.commit("IS_LOADING", true);
      let dataPost = {
        mailId: this.id,
        balId: this.balSelected,
        commentaire: this.commentaire
      }
      this.$axios
        .post("/espaceGestion/mail/forward", dataPost)
        .then(response => {
          this.$store.commit("IS_LOADING", false);
          // console.log(response.data)
          this.processDataMail(response.data.mail)
          this.$swal(
            {
              position: 'top',
              type: 'success',
              title: 'Transfert',
              text: 'Le mail a bien été transféré.',
              showConfirmButton: false,
              timer: 5000
            })
          this.commentaire = '';
          this.balSelected = null;
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    cancelTransfert () {
      this.commentaire = '';
      this.$refs['modal-commentaire'].hide();
      this.balSelected = null;
    },
    validateData (exception) {
      this.clearErrors();
      let valid = true

      if (this.balSelected === null) {
        this.errors.balTransfert = 'Vous devez choisir une BAL de destination.'
        valid= false;
      }

      return valid;
    },
    manageNeutralise() {
      let message = this.mail.is_spam || this.mail.is_neutralised ? "Voulez-vous vraiment ré-activer ce mail ? Un dossier sera automatiquement créé." : "Voulez-vous vraiment neutraliser ce mail ?"
      let textBoutonValide = this.mail.is_spam || this.mail.is_neutralised ? "Ré-activer ?" : "Neutraliser ?"
      this.$swal
        .fire({
          title: "Êtes-vous sûr?",
          text: message,
          type: "warning",
          reverseButtons: true,
          showCancelButton: true,
          allowOutsideClick: false,
          cancelButtonColor: "#ff1744",
          confirmButtonText: "Annuler",
          cancelButtonText: textBoutonValide
        })
        .then(result => {
          if (!result.value) {
            let self = this;
            let dataPost = {
              mailIds: this.id
            }
            this.$store.commit("IS_LOADING", true);
            
            this.$axios
              .post("/espaceGestion/mail/neutralise", dataPost)
              .then(response => {
                this.$store.commit("IS_LOADING", false);
                // console.log(response.data)
                this.processDataMail(response.data.mail)
              })
              .catch(function(error) {
                // console.log(error)
                self.$store.commit("IS_LOADING", false);
                self.$swal({
                  position: "top",
                  type: "error",
                  title: "Attention !!",
                  text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                  showConfirmButton: false,
                  timer: 5000
                })
              })
          }
      })
    },
    returnBack() {
      this.$router.push({ path: "/espace-gestion/mail", query: { mf: this.$route.query.mf, mi: this.$route.query.mi, text: this.$route.query.text, nir: this.$route.query.nir, dd: this.$route.query.dd, da: this.$route.query.da, ss: this.$route.query.ss, bals: this.$route.query.bals, page: this.$route.query.page, limit: this.$route.query.limit }})
    },
    clearErrors() {
      this.errors.balTransfert = '';
    },
    getReadableFileSize(fileSizeInBytes) {
      let i = -1;
      let byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
      do {
        fileSizeInBytes = fileSizeInBytes / 1024;
        i++;
      } while (fileSizeInBytes > 1024);

      return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
    },
    getIconSrc (pj) {
      let images = require.context('../../../assets/images/', false, /\.png$/)
      let icon = this.extensionIcon[pj.extension.trim().toLowerCase()] !== undefined ? this.extensionIcon[pj.extension.trim().toLowerCase()] : this.extensionIcon['inconnu']

      return images('./' + icon)
    },
    getHrefDossier() {
      let routeData = null;
      // console.log('this.mail.dossiers',this.mail.dossiers)
      if (this.mail.dossiers && this.mail.dossiers.length > 0) {
        let dossierId = this.mail.dossiers[0].id;
        let mainTraitement = this.getDossierMainTraitement(this.mail.dossiers[0]);
        let traitementId = mainTraitement ? mainTraitement.id : 2;
        routeData = this.$router.resolve({name: 'fiche dossier', params: { id: dossierId }, query: {traitementId: traitementId, modeVisualisation: 'monActiviteProd', seqDossiers: dossierId, dossierId: dossierId}});
      }

      return routeData !== null ? routeData.href : '';
    },
    formatDate(textDate) {
      let date = textDate !== null ? new Date(textDate).toLocaleString("fr-FR") : "-";
      return date;
    },
    getDossierMainTraitement(dossier) {
      let traitementQC = this.allTraitements.reduce((res, traitement) => {
            return traitement.libelle_technique === 'qualification_courrier' ? traitement : res;
          },{});
      let traitement = null;
      if (isEmpty(dossier.type)) {
        // Si on n'a pas de type, c'est que le dossier est au PFE
        traitement = traitementQC;
      } else {
        traitement = getMainTreatmentBasedOnType(dossier, this.allTraitements);
        // On regarde si le dossier à un statut pour ce traitement, si ce n'est pas le cas c'est que le dossier est encore en qualification
        if (traitement) {
          let find = dossier.status.reduce((res, status) => parseInt(status.pivot.traitement_id,10) === parseInt(traitement.id,10) ? true : res,false);
          if (!find) {
            traitement = traitementQC;
          }
        }
      }

      return traitement;
    },
    deleteSpam() {
      let self = this;
      this.$swal.fire({
        title: 'Êtes-vous sûr?',
        text: 'Voulez-vous vraiment supprimer ce mail ?',
        type: 'warning',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonColor:"#ff1744",
        confirmButtonText: 'Annuler',
        cancelButtonText: 'Supprimer',
      }).then((result) => {
        if (result.value !== true) {
          let dataPost = {
            mailIds: this.mail.id
          }
          this.$store.commit('IS_LOADING', true);
          this.$axios
            .post("/espaceGestion/mail/delete", dataPost)
            .then(response => {
              this.$store.commit('IS_LOADING', false);
              this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'Le fichier a bien été supprimé',showConfirmButton: false, timer: 3000});
              this.$router.push({ path: "/espace-gestion/mail", query: { mf: this.$route.query.mf, mi: this.$route.query.mi, text: this.$route.query.text, nir: this.$route.query.nir, dd: this.$route.query.dd, da: this.$route.query.da, ss: this.$route.query.ss, bals: this.$route.query.bals, page: this.$route.query.page, limit: this.$route.query.limit }});
            })
            .catch(function(error){
              console.log(error)
              self.$store.commit('IS_LOADING', false)
              let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
                if (error.response && error.response.status === 424) {
                  textError = error.response.data.message;
                }
                self.$store.commit('IS_LOADING', false);
                self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:textError, showConfirmButton: false, timer: 5000});
            })
        }
      })
    },
  }
}
</script>
<style scoped>
.borded-right {
  border-right: 1px solid #d5d5d5;
}
div.col-sm-1 {
  padding: 0;
}
.pre-formatted {
  white-space: pre;
}
ul.liste-pj {
  padding: 0;
  list-style: none;
}
ul.liste-pj li img {
  width: 16px;
}
ul.liste-pj li a {
  text-decoration: none;
}
.smaller {
  font-size: 0.9em;
}
.block-mail, .historique {
  margin-bottom: 0;
}
.info-dossier {
  margin-bottom: 1rem;
}
.historique .card-body {
  padding: 0 1rem;
}
.historique .card-body p {
  margin-bottom: 0;
}
a, a:visited, a:link {
  text-decoration: none;
}
.nopadding {
  padding-right: 0;
}
.neutralise, .neutralise .card-body .list-group .list-group-item {
  background-color: #ECECEC;
}
</style>
